/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CampaignBenchmarkDto } from './campaign-benchmark-dto';
import { CampaignAttributedRevenueDayDto } from './campaign-attributed-revenue-day-dto';
import { CampaignDetailKpisDto } from './campaign-detail-kpis-dto';
import { CampaignDetailSeriesDto } from './campaign-detail-series-dto';
import { AnalyticsPeriodDto } from './analytics-period-dto';


export interface CampaignDetailAnalyticsResponseDto { 
    period: AnalyticsPeriodDto;
    type: CampaignDetailAnalyticsResponseDto.TypeEnum;
    kpis: CampaignDetailKpisDto;
    benchmark: CampaignBenchmarkDto;
    series: Array<CampaignDetailSeriesDto>;
    attributedRevenueByDay: Array<CampaignAttributedRevenueDayDto>;
    seriesUnit: CampaignDetailAnalyticsResponseDto.SeriesUnitEnum;
}
export namespace CampaignDetailAnalyticsResponseDto {
    export const TypeEnum = {
        _0: '0',
        _1: '1',
        _2: '2',
        _3: '3',
        _4: '4'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
    export const SeriesUnitEnum = {
        HourSinceSend: 'hour_since_send',
        Day: 'day'
    } as const;
    export type SeriesUnitEnum = typeof SeriesUnitEnum[keyof typeof SeriesUnitEnum];
}


